import TrailerRequirementsFormContainer from "./TrailerRequirementsFormContainer";

export default TrailerRequirementsFormContainer;
